import { render, staticRenderFns } from "./DetailsModule.vue?vue&type=template&id=20470472"
import script from "./DetailsModule.vue?vue&type=script&lang=js"
export * from "./DetailsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports